import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle2 ellipsis" }
const _hoisted_2 = { class: "text-h4" }

import { DeepReadonlyObject } from "rxdb"
import SfxCard from "src/components/card/SfxCard.vue"
import SfxDataPoint from "src/components/data-point/SfxDataPoint.vue"
import { ItemModel } from "src/util/types/dataModels/itemModel"
import { PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardModel',
  props: {
  itemModel: {
    type: Object as PropType<DeepReadonlyObject<ItemModel>>,
    required: true,
  },

  itemClassDesignation: {
    type: String,
  },
},
  setup(__props) {

const props = __props

//endregion

return (_ctx: any,_cache: any) => {
  const _directive_truncate_middle = _resolveDirective("truncate-middle")!

  return (_openBlock(), _createBlock(SfxCard, {
    clickable: "",
    class: "q-my-md",
    "img-src": 'https://picsum.photos/1920/1080',
    hasImg: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(props.itemClassDesignation), 1),
      _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
        [_directive_truncate_middle, props.itemModel?.designation]
      ]),
      _createVNode(SfxDataPoint, {
        "card-field": "",
        label: _ctx.$t('sfxCard.model_code')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.itemModel.model_code), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(SfxDataPoint, {
        "card-field": "",
        label: _ctx.$t('sfxCard.model_manufacturer')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.itemModel.manufacturer), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }))
}
}

})